import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TariffUuids } from '@products/models/tariff.model';
import { Hash } from '@store/helpers/helper.interface';

export const BookingActions = createActionGroup({
  source: 'Booking',
  events: {
    'Set claimed ticket hash': (claimedTicketHash: Hash) => ({ claimedTicketHash }),
    'Set is claimed ticket hash valid': (isClaimedTicketHashValid: boolean) => ({ isClaimedTicketHashValid }),
    'Set is anonymous product sent to API': (isAnonymousProductSentToAPI: boolean) => ({ isAnonymousProductSentToAPI }),
    'Set booked tariff uuids': props<{ addBookedTariffUuids: TariffUuids; removeBookedTariffUuids: TariffUuids }>(),
    'Remove booked tariff uuids': (bookedTariffUuids: TariffUuids) => ({ bookedTariffUuids }),
    'Reset product bookings': emptyProps()
  }
});
